import React from "react"
import "./Section.02.Resort.css"

export default function ResortSection(params) {

    const {rescue, values} = params
    
    return <li className="accordion">
        <input type="checkbox" className="accordion" id="acc-resort"/>
        <label className="accordion" htmlFor="acc-resort">Podaci za skijalište</label>
        <section className="accordion">
        
            <div className="field">
      		    <label htmlFor="ski_pass" className="above">Broj ski karte</label>
      		    <input type="text" value={rescue.rescue?.ski_pass || ''} id="ski_pass" placeholder="npr. 150/555345" onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
            </div>
            
            <div className="field">
      		    <label htmlFor="accommodation" className="above">Smeštaj u centru</label>
      		    <input type="text" value={rescue.rescue?.accommodation || ''} id="accommodation" placeholder="npr. Hotel Grand" onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
            </div>
            
            <div className="field">
      		    <label htmlFor="subject_category" className="above">Kategorija</label>
      		    <input type="text" value={rescue.rescue?.subject_category || ''} list="subject_categories" id="subject_category" placeholder="Izaberi iz liste ili upiši sam..." onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
      		    <datalist id="subject_categories">
          		    {values?.subject_categories?.map(value => <option key={value}>{value}</option>)}
      		    </datalist>
      		    <label id="helmet-box">
                    <input type="checkbox" id="helmet" checked={rescue.rescue?.helmet || false} onChange={event => rescue.setField("helmet", event.target.checked)} disabled={rescue.isReadOnly}/>
                    <span>Ima kacigu</span>
                </label>
            </div>
        </section>
    </li>
    
}